import React from 'react';
import { useTranslation } from 'react-i18next';

import SubHeading from '../SubHeading/SubHeading';
import '../css/Newsletter.css';

const Newsletter = () => {
  const { t } = useTranslation();

  return (
    <div className="app__newsletter">
      <div className="app__newsletter-heading">
        <SubHeading title={t('footer.newsletter.title')} />
        <h1 className="headtext__cormorant">{t('footer.newsletter.heading')}</h1>
        <p className="p__opensans">{t('footer.newsletter.description')}</p>
      </div>
      <div className="app__newsletter-input flex__center">
        <input 
          type="email" 
          placeholder={t('footer.newsletter.placeholder')} 
        />
        <button type="button" className="custom__button">
          {t('footer.newsletter.subscribe')}
        </button>
      </div>
    </div>
  );
};

export default Newsletter;